module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pos/returninvoices/returninvoices-show/returninvoices-show.component.scss
// module id = ./src/app/views/pos/returninvoices/returninvoices-show/returninvoices-show.component.scss
// module chunks = main